




import Auth from "../shared/Auth";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SignOut extends Vue
{
	mounted()
	{
		new Auth().signOut(() =>
		{
			this.$router.push({ name: "index" });
		});
	}
}
